import { useEffect, useRef } from 'react'
import { postDataAPI } from '../../../lib/api'
import type { SignupUser } from '../SignupPage'
import { OnboardingStep } from './steps'

export default function Step01AutoSendOtp({
  setStep,
  user,
  setUser,
}: {
  setStep: (n: number) => void
  user: SignupUser
  setUser: React.Dispatch<React.SetStateAction<SignupUser>>
}) {
  const hasAutoSent = useRef(false)

  useEffect(() => {
    if (!user?.email) return
    if (hasAutoSent.current) return
    hasAutoSent.current = true

    const run = async () => {
      try {
        await postDataAPI('auth/sendOtpToEmail', { email: user.email })
      } catch (e) {
        // keep behavior consistent: still proceed so user can resend
        console.error('Failed to send OTP:', e)
      } finally {
        setUser((prev) => ({ ...prev, email: user.email }))
        setStep(OnboardingStep.VerifyOtp)
      }
    }

    run()
  }, [setStep, setUser, user.email])

  return null
}

